module.exports = __webpack_public_path__ + "static/media/lpi01.a9fd09f5.jpg";